import React from 'react';

export type ImageDetails = {
  url: string;
  breakpoint: string;
};

const imgTypes = ['webp', 'jpg', 'png'];
export type ImgType = typeof imgTypes[number];

/**
 * Returns an array of source HTML elements for a given input, allows the
 * correct image is shown at varying screen sizes. The result should be nested
 * within a picture element
 *
 * @param images an array of image sources + the correct breakpoint for that image. note: all sources should be of the same file type
 * @param imgType the corresponding file type for the given image sources
 */
export const getSourceElements = (
  images: ImageDetails[] = [],
  imgType: string
): React.ReactNode => {
  return images.map((image, index) => (
    <source
      key={`grid-source-${imgType}-${index}`}
      type={`image/${imgType}`}
      srcSet={image.url}
      media={`(max-width: ${image.breakpoint}px)`}
    />
  ));
};

/**
 * Generates the srcset string of imgs at different breakpoints for a single image
 */
export const getSrcSet = (images: ImageDetails[] = []): string => {
  return images.map((image) => `${image.url} ${image.breakpoint}w`).join(', ');
};
